export function getOpenSplitUserTemplateProperties() {
  const properties =
    'width=961,height=' +
    window.innerHeight +
    ',left=' +
    (window.screenX + window.innerWidth - 961) +
    ',top=' +
    (window.screenTop + 50) +
    ',directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,';
  return properties;
}



// WEBPACK FOOTER //
// ./src/functions/pages/split_user_template/index.js